/**
 * Limits shared by the contact list pop-ups (FR60 contact list, FR119 share a contact).
 */

export const CONTACT_PAGE_SIZE = 10;
export const CONTACT_LOAD_THRESHOLD = 0.7;
export const SEARCH_DEBOUNCE_MS = 3000;
export const SEARCH_MAX_LENGTH = 255;

export const LETTER_GROUP_FALLBACK = '#';
